import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./VacationFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import VacationFormStepOne from "./VacationFormSteps/VacationFormStepOne";

const VacationForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);
  
  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        vacationType: _initialValues?.vacationType?.uuid
          ? { value: _initialValues?.vacationType?.uuid }
          : null,
        responsible: _initialValues?.responsible?.uuid
          ? { value: _initialValues?.responsible?.uuid }
          : null,
        replacement: _initialValues?.replacement?.uuid
          ? { value: _initialValues?.replacement?.uuid }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="VacationForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <VacationFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default VacationForm;
